import React from "react"
import { useMyProfileQuery } from "../../../../services/profileService/profile-api";
import { toggleVobAssignmentAddModal, toggleVobAssignmentBulkImportModal } from "../../../../app/slices/ProfileModuleSlice";
import { useAppDispatch } from "../../../../app/hooks";
import VobAssignmentAdd from "./VobAssignmentAdd";
import VobAssignmentEdit from "./VobAssignmentEdit";
import { VobAssignmentBulkImport } from "./VobAssignmentBulkImport";
import VobAssignmentsList from "./VobAssignmentsList";
import { Profile } from "../../../../services/profileService";
import { Button, Card, Stack } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useCenterListQuery } from "../../../../services/orgService/org-api";

type ownProps = {
    profile: Profile;
}

function VobAssignments(props: ownProps) {
    const { data } = useMyProfileQuery();
    const { data: centers } = useCenterListQuery();
    const dispatch = useAppDispatch();
    
    const canAccess = (): boolean => {
        if (data?.role === 'Admin' || data?.role === 'RevCycle Admin' || data?.role === 'Incident Admin') {
            return true;
        }
        return false;
    }

    return <React.Fragment>
        <Card sx={{ padding: '5px', borderRadius: '10px' }}>
            <Stack direction='row' justifyContent='space-between' alignItems='flex-end' marginTop='10px' marginBottom='5px' paddingBottom='5px' borderBottom='3px solid gray'>
                <h5>VOB Assignments</h5>
                {canAccess() && <Stack direction='row' spacing={1}>
                    <Button variant="outlined" color='secondary' size='large'
                        onClick={() => dispatch(toggleVobAssignmentBulkImportModal())} startIcon={<FileUploadIcon />}>
                        Bulk Import</Button>
                    <Button variant="outlined" color='primary' size='large'
                        onClick={() => dispatch(toggleVobAssignmentAddModal())} startIcon={<AddCircleOutlineIcon />}>
                        Add</Button>
                </Stack>}
            </Stack>
            <VobAssignmentsList profile={props.profile} centers={centers || []} />
        </Card>
        <VobAssignmentAdd profile={props.profile} centers={centers || []} />
        <VobAssignmentEdit profile={props.profile} centers={centers || []} />
        <VobAssignmentBulkImport />
    </React.Fragment>
}

export { VobAssignments }
